<template>
    <div class="pantalla-menu">
        <div class="container-mob w-100">
            <div class="text-end">
                <a href="/perfil" class="color-red pe-3">
                    <i class="fas fa-chevron-left"></i>
                </a>
            </div>
            <div class="form-login mt-2">
                <h2 class="mb-3">Editar Perfil</h2>
                <div class="notification text-danger" v-if="errors">
                    <ul>
                        <ul v-for="(fields, key) in errors">
                            <b>{{ key }}:</b>
                            <li v-for="error in fields">{{ error }}</li>
                        </ul>
                    </ul>
                </div>
                <form method="post" @submit.prevent="editar">
                    <label>Nombre:</label>
                    <div class="input-group">
                        <span class="input-group-text" id="basic-addon1"><i class="fas fa-user"></i></span>
                        <input type="text" class="form-control" placeholder="Nombre" aria-label="Nombre" aria-describedby="basic-addon1" id="nombre" v-model="nombre">
                    </div>
                    <label>Apellido:</label>
                    <div class="input-group">
                        <span class="input-group-text" id="basic-addon5"><i class="fas fa-user"></i></span>
                        <input type="text" class="form-control" placeholder="Apellido" aria-label="Apellido" aria-describedby="basic-addon5" id="apellido" v-model="apellido">
                    </div>
                    <label>Email:</label>
                    <div class="input-group">
                        <span class="input-group-text" id="basic-addon3"><i class="fas fa-envelope"></i></span>
                        <input type="email" class="form-control" placeholder="Email" aria-label="Email" aria-describedby="basic-addon3" name="email" id="email" v-model="email">
                    </div>

                    <p class="mt-3 text-center">Introduce el nombre y logo de tu empresa si quieres personalizar tus presupuestos:</p>

                    <label>Empresa:</label>
                    <div class="input-group">
                        <span class="input-group-text"><i class="fas fa-user"></i></span>
                        <input type="text" class="form-control" placeholder="Nombre de la empresa" id="empresa" v-model="empresa">
                    </div>
                    <label>Logo Empresa:</label>
                    <div class="input-group">
                        <span class="input-group-text"><i class="fas fa-star"></i></span>
                        <input type="file" class="form-control" @change="grabFile" ref="logo">
                    </div>
                    <div class="text-center mt-5">
                        <button type="button" class="btn-form" @click="editar">GUARDAR</button>
                    </div>

                </form>
            </div>
        </div>
        <menu-component></menu-component>
    </div>

</template>

<script>
export default {
    data() {
        return {
            nombre: '',
            apellido: '',
            email: '',
            empresa: '',
            logo: null,
            errors: null
        };
    },
    methods: {
        editar() {
            this.$store
            .dispatch("editUser", {
                nombre: this.nombre,
                apellido: this.apellido,
                email: this.email,
                empresa: this.empresa,
                logo: this.logo,
            })
            .then(response => {
                this.$router.push({name: "perfil"});
            })
            .catch(error => {
                this.errors = error.response.data.errors;
            });
        },
        grabFile(){
            this.logo = this.$refs.logo.files[0];
        }
    },
    mounted: function () {
        this.$store
        .dispatch("getPerfil")
        .then(response => {
            this.nombre = response.data.nombre;
            this.apellido = response.data.apellido;
            this.email = response.data.email;
            this.empresa = response.data.empresa;
        })
        .catch(error => {
            this.errors = error.response.data;
        });
    },
};
</script>

<style>
.logo-header {
    max-width: 150px;
}

.input-group-text {
    background: #FAFAFA;
    border: none;
    border-radius: 0px;
    padding-top: 20px;
    padding-bottom: 20px;
    color: #989898;
    width: 40px;
    margin-left: auto;
    margin-right: auto;
}

.input-group > .form-control, .input-group > .form-select {
    background: #FAFAFA;
    border: none;
    border-radius: 0px;
}

.input-group:last-child {
    border-top: 1px solid #EDEDED;
}

.input-group input:focus {
    box-shadow: none;
}

.input-group input::placeholder {
    font-size: 14px;
}

.btn-form {
    background: #F9423E;
    color: white;
    border-radius: 100px;
    text-align: center;
    padding: 5px 40px;
    border: 0px;
    margin-left: auto;
    margin-right: auto;
}

.enlace-form a {
    color: #989898;
    font-size: 12px;
    text-decoration: none;
}
</style>
